import axios from "axios";

import config from "_private/config/request";

// 创建一个axios实例
const service = axios.create(config.options);
config.interceptors(service);

export default service;
